import { Dropdown, Layout } from 'antd';
import { Profile, ArrowUp, ArrowDown } from 'assets/images';
import PropType from 'prop-types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectGlobalUserInfo } from 'state/global/auth/selector';
import { selectGlobalMyProfile } from 'state/global/profile/selector';
import { getUserName } from 'util/auth';
import { NotificationNavigation } from './components/NotificationNavigation';
import LogoutMenu from './LogoutMenu';

const HeaderComponent = ({ setShowProfile }) => {
  const { Header } = Layout;
  const [visibleUserProfile, setVisibleUserProfile] = useState(false);
  const globalUserInfo = useSelector((state) => selectGlobalUserInfo(state));
  const globalMyProfile = useSelector((state) => selectGlobalMyProfile(state));

  const onVisibleChange = (visible) => {
    setVisibleUserProfile(visible);
  };

  const onSetShowProfile = (isOpen) => {
    setShowProfile(isOpen);
    setVisibleUserProfile(false);
  };

  return (
    <Header className="header">
      <NotificationNavigation />

      <Dropdown
        open={visibleUserProfile}
        onOpenChange={onVisibleChange}
        overlay={LogoutMenu({ setShowProfile: onSetShowProfile })}
        overlayClassName="user-dropdown-overlay"
        trigger={['click']}>
        <div className="user-info-body">
          <Profile className="user-profile-icon" />

          <span className="user-info-name">
            {getUserName(globalUserInfo?.name, globalMyProfile?.displayName)}
          </span>

          {visibleUserProfile ? (
            <ArrowUp className="arrow-up" />
          ) : (
            <ArrowDown className="arrow-down" />
          )}
        </div>
      </Dropdown>
    </Header>
  );
};

HeaderComponent.propTypes = {
  setShowProfile: PropType.func.isRequired
};

export default HeaderComponent;
